<template>
    <nav class="navbar navbar-expand-lg navbar-dark app-navbar">
        <div class="container-fluid">
            <router-link to="/" class="navbar-brand d-flex align-items-center gap-2">
                <span>🎤</span>
                <span>My<span class="brand-accent">Concerts</span></span>
            </router-link>
            <button class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item">
                        <router-link to="/" class="nav-link" exact-active-class="active">Home</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/ArtistsSeenPage" class="nav-link" exact-active-class="active">Artists</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/PlacesPage" class="nav-link" exact-active-class="active">Places</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/VenuesPage" class="nav-link" exact-active-class="active">Venues</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link to="/SpotifyPage" class="nav-link" exact-active-class="active">Spotify</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'NavigationMenu'
    }
</script>
